import { useNavigate } from 'react-router-dom'
import { CoverCard } from '@shared/ui/CoverCard'
import { ROUTES } from '@shared/config/routes'
import { useCategories, useContentAccess } from '../../../hooks/useApi'
import type { CategoryBase } from '../../../types/api'
import HomeBlock from './HomeBlock'

/**
 * Карточки разделов: «Рецепты», «Декор», «Теория» и прочие верхнего уровня.
 *
 * Пришли на место тегов и сетки разделов — те дублировали друг друга. Состав
 * берём с бэка, а не из списка в коде: разделы заводит админка.
 */
const SectionCards = () => {
  const navigate = useNavigate()
  const { hasSubscription } = useContentAccess()
  const { data: categories } = useCategories(hasSubscription)

  // У ответа есть обёртка `categories`, а уровень приходит не всегда: верхние
  // разделы отличаются отсутствием родителя.
  const sections: CategoryBase[] = (categories?.categories ?? []).filter(
    category => (category.level ?? 1) === 1 && !category.parent_category_id
  )

  if (sections.length === 0) return null

  return (
    <HomeBlock title="Библиотека" withLogo>
      {sections.map(section => (
        <CoverCard
          key={section.category_id}
          title={section.name}
          image={section.icon_url}
          // Раздел открывается в «Базе» уже выбранным — там же фильтры и поиск.
          onClick={() =>
            navigate(`${ROUTES.BASE}?section=${section.category_id}`)
          }
        />
      ))}
    </HomeBlock>
  )
}

export default SectionCards
